module.exports = __webpack_public_path__ + "img/Sonic2.d841b137.png";